/* 🤖 this file was generated by svg-to-ts */
export const matIconWidthFull: {
  name: 'width-full';
  data: string;
} = {
  name: 'width-full',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h1v12H4zm3 0V6h10v12H7zm13 0h-1V6h1v12z"/></svg>`
};
